/* eslint-disable import/prefer-default-export */

import { TilstandsrapportActionCreators, TilstandsrapportActionTypes } from './types';

export const doUpdateLoanInformation = (tilstandsrapportId, field, value): TilstandsrapportActionCreators => {
  return {
    type: TilstandsrapportActionTypes.UPDATE_LOAN_INFORMATION,
    tilstandsrapportId,
    field,
    value: parseFloat(value),
  };
};
